import moment from 'moment';

export class PsDate {

    _date;

    constructor(date) {
        this._date = date;
    }

    static fromNow() {
        return new this(new Date());
    }

    static fromDate(date) {
        return new this(date);
    }

    static fromISOString(date) {
        return new this(new Date(date));
    }

    static fromMomentDate(date) {
        PsDate.guardMomentValid(date);
        return new this(date.toDate());
    }

    static fromUnckeckedDDMMYYYY(pattern) {
        try {
            return PsDate.fromDDMMYYYY(pattern);
        } catch (e) {
            return null;
        }
    }

    // 05122000 -> 05/12/2000
    static fromDDMMYYYY(pattern) {
        const day = pattern.slice(0, 2);
        const month = pattern.slice(2, 4);
        const year = pattern.slice(4, 8);
        const date = `${day}/${month}/${year}`;
        PsDate.guardDateLength(date);
        const momentDate = moment(date, 'DD/MM/YYYY');
        PsDate.guardMomentValid(momentDate);
        return new PsDate(momentDate.toDate());
    }

    static guardDateLength(pattern) {
        const isInvalidLength = pattern.length !== 10;
        if ( isInvalidLength ) throw new Error('Invalid length date');
    }

    static guardMomentValid(date) {
        const isInvalidDate = date.toString() === 'Invalid date';
        if ( isInvalidDate ) throw new Error('Invalid date');
    }

    clone() {
        return PsDate.fromDate(new Date(this.toDate().getTime()));
    }

    subtractDays(days) {
        const momentDate = this.toMomentDate().subtract(days - 1, 'd');
        return PsDate.fromMomentDate(momentDate);
    }

    time() {
        return this._date.getTime();
    }

    isBefore(date) {
        const startDate = this.time();
        const endDate = date.time();
        return startDate < endDate;
    }

    isAfter(date) {
        const startDate = this.time();
        const endDate = date.time();
        return startDate > endDate;
    }

    isEquals(date) {
        const startDate = this.time();
        const endDate = date.time();
        return startDate === endDate;
    }

    date() {
        return this._date;
    }

    toMomentDate() {
        return moment(this._date);
    }

    // 05/12/2000 -> 05122000
    toDDMMYYYY() {
        return moment(this._date)
            .format('DD/MM/YYYY')
            .split('/')
            .join('');
    }

    toDateString() {
        return moment(this.date()).format('DD/MM/YYYY');
    }

    toISOFirstTime() {
        return `${this.toISODate()}T00:00:00.000Z`;
    }

    toISOLastTime() {
        return `${this.toISODate()}T23:59:59.999Z`;
    }

    toISODate() {
        return this.toISO().split('T')[0];
    }

    toISO() {
        return this.toISOStringWithoutTimezone(this._date);
    }

    toISOStringWithoutTimezone(date) {
        return moment(date).toISOString(true);
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/model/PsDate.js